const TABS = [
  { id: "videos", label: "Video Tutorials", icon: "bi-play-btn" },
  { id: "tickets", label: "Support Tickets", icon: "bi-life-preserver" }
];

const HERO_CARD = {
  title: "Learn at Your Own Pace",
  subtitle: "Browse our video tutorials to master the platform features. Available 24/7 for your convenience."
};

const INSIGHTS_CARD = {
  title: "Insights",
  subtitle: "Helpful highlights to guide your next steps",
  items: [
    {
      id: 1,
      title: "Reports & Analytics",
      description: "Generate reports to understand compliance and performance."
    },
    {
      id: 2,
      title: "Settings & Configuration",
      description: "Customize your account and organization preferences."
    },
    {
      id: 3,
      title: "Document Management",
      description: "Organize verification and compliance documents efficiently."
    }
  ]
};

const VIDEO_PLAYLISTS = [
  {
    id: 1,
    category: "Basics",
    badge_class: "bg-warning text-dark",
    duration: "5:55",
    title: "Reports & Analytics",
    description: "Generate reports and understand your compliance metrics."
  },
  {
    id: 2,
    category: "Basics",
    badge_class: "bg-warning text-dark",
    duration: "4:30",
    title: "Settings & Configuration",
    description: "Customize your account and organization settings."
  },
  {
    id: 3,
    category: "Documents",
    badge_class: "bg-warning text-dark",
    duration: "6:45",
    title: "Document Management",
    description: "Upload, organize, and access compliance documents."
  },
  {
    id: 4,
    category: "Basics",
    badge_class: "bg-warning text-dark",
    duration: "5:30",
    title: "Platform Overview",
    description: "Get a tour of the core navigation and features."
  }
];

const QUICK_TIPS = {
  title: "Quick Tips",
  subtitle: "Helpful hints to get the most out of the platform",
  items: [
    {
      id: 1,
      title: "Upload Documents Early",
      description: "Start uploading verification documents as soon as possible to avoid last-minute rushes."
    },
    {
      id: 2,
      title: "Track Your Progress",
      description: "Use the dashboard to monitor your B-BBEE element scores and identify areas for improvement."
    },
    {
      id: 3,
      title: "Set Up Alerts",
      description: "Enable notifications to stay informed about deadlines and important updates."
    }
  ]
};

const SUPPORT_CARD = {
  title: "Need help with something specific?",
  subtitle: "Raise a support ticket or browse our guides to get answers fast.",
  primary_action: "New Ticket",
  secondary_action: "View Help Guides",
  contact_title: "Prefer to talk?",
  contact_text: "Email support@yourplatform.com or call +27 11 555 1234. We are available 24/7."
};

const SUPPORT_STATS = [
  {
    id: "open",
    label: "Open Tickets",
    count: 0,
    icon: "bi-clock-history",
    icon_bg_class: "bg-primary-subtle",
    icon_color_class: "text-primary",
    text_color_class: "text-primary",
    card_bg_class: "bg-white shadow-sm"
  },
  {
    id: "resolved",
    label: "Resolved",
    count: 0,
    icon: "bi-check2-circle",
    icon_bg_class: "bg-success-subtle",
    icon_color_class: "text-success",
    text_color_class: "text-success",
    card_bg_class: "bg-white shadow-sm"
  },
  {
    id: "total",
    label: "Total Tickets",
    count: 0,
    icon: "bi-chat-dots",
    icon_bg_class: "bg-success-subtle",
    icon_color_class: "text-success",
    text_color_class: "text-dark",
    card_bg_class: "bg-white shadow-sm"
  },
  {
    id: "priority",
    label: "High Priority",
    count: 0,
    icon: "bi-exclamation-circle",
    icon_bg_class: "bg-warning-subtle",
    icon_color_class: "text-warning",
    text_color_class: "text-warning",
    card_bg_class: "bg-white shadow-sm"
  }
];

const SUPPORT_EMPTY = {
  icon_class: "bi-question-circle",
  title: "No support tickets yet",
  description: "Click \"New Ticket\" to submit your first support request"
};

const clone_deep = (obj) => JSON.parse(JSON.stringify(obj));

export default {
  name: "HelpSupportSection",
  data() {
    return ({
      page_title: "Help & Support",
      page_subtitle: "Video tutorials and support tickets to assist you 24/7",
      active_tab: "videos",
      tabs: TABS,
      hero_card: HERO_CARD,
      insights_card: clone_deep(INSIGHTS_CARD),
      video_playlists: VIDEO_PLAYLISTS,
      quick_tips: clone_deep(QUICK_TIPS),
      support_card: SUPPORT_CARD,
      support_stats: clone_deep(SUPPORT_STATS),
      support_empty: SUPPORT_EMPTY
    });
  },
  methods: {
    select_tab(tab_id) {
      this.active_tab = tab_id;
    }
  }
};